import { Node, mergeAttributes, wrappingInputRule } from '@tiptap/core';
const inputRegex = /^\s*>\s$/;
const Blockquote = Node.create({
  name: 'blockquote',
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: 'block+',
  group: 'block',
  defining: true,
  parseHTML() {
    return [{
      tag: 'blockquote'
    }];
  },
  renderHTML(_ref) {
    let HTMLAttributes = _ref.HTMLAttributes;
    return ['blockquote', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands() {
    return {
      setBlockquote: () => _ref2 => {
        let commands = _ref2.commands;
        return commands.wrapIn(this.name);
      },
      toggleBlockquote: () => _ref3 => {
        let commands = _ref3.commands;
        return commands.toggleWrap(this.name);
      },
      unsetBlockquote: () => _ref4 => {
        let commands = _ref4.commands;
        return commands.lift(this.name);
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      'Mod-Shift-b': () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [wrappingInputRule({
      find: inputRegex,
      type: this.type
    })];
  }
});
export { Blockquote, Blockquote as default, inputRegex };